/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */
import React from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';
import { EuiIcon } from '../icon';
import { useLoadingAriaLabel } from './_loading_strings';
import { euiLoadingElasticStyles } from './loading_elastic.styles';
export var SIZES = ['m', 'l', 'xl', 'xxl'];
export var EuiLoadingElastic = ({
  size = 'm',
  className,
  'aria-label': ariaLabel,
  ...rest
}) => {
  const styles = euiLoadingElasticStyles();
  const cssStyles = [styles.euiLoadingElastic];
  const defaultLabel = useLoadingAriaLabel();
  const classes = classNames('euiLoadingElastic', className);
  return <span className={classes} css={cssStyles} role="progressbar" aria-label={ariaLabel || defaultLabel} {...rest}>
      <EuiIcon type="logoElastic" size={size} />
    </span>;
};
EuiLoadingElastic.propTypes = {
  className: PropTypes.string,
  "aria-label": PropTypes.string,
  "data-test-subj": PropTypes.string,
  size: PropTypes.any
};

try {
  EuiLoadingElastic.__docgenInfo = {
    tags: {},
    filePath: '/app/src/components/loading/loading_elastic.tsx',
    description: '',
    displayName: 'EuiLoadingElastic',
    methods: [],
    props: {
      className: {
        defaultValue: null,
        description: '',
        name: 'className',
        parent: {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        }, {
          fileName: 'app/node_modules/@types/react/index.d.ts',
          name: 'HTMLAttributes'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-label': {
        defaultValue: null,
        description: 'Defines a string value that labels the current element.\n' + '@see aria-labelledby.',
        name: 'aria-label',
        parent: {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        }, {
          fileName: 'app/node_modules/@types/react/index.d.ts',
          name: 'AriaAttributes'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'data-test-subj': {
        defaultValue: null,
        description: '',
        name: 'data-test-subj',
        parent: {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      size: {
        defaultValue: {
          value: 'm'
        },
        description: '',
        name: 'size',
        parent: {
          fileName: 'app/src/components/loading/loading_elastic.tsx',
          name: 'EuiLoadingElasticProps'
        },
        declarations: [{
          fileName: 'app/src/components/loading/loading_elastic.tsx',
          name: 'EuiLoadingElasticProps'
        }],
        required: false,
        type: {
          name: 'enum',
          raw: '"m" | "l" | "xl" | "xxl"',
          value: [{
            value: '"m"'
          }, {
            value: '"l"'
          }, {
            value: '"xl"'
          }, {
            value: '"xxl"'
          }]
        }
      }
    },
    extendedInterfaces: ['CommonProps', 'HTMLAttributes', 'AriaAttributes', 'DOMAttributes', 'EuiLoadingElasticProps']
  };
} catch (e) {}